
import { 
    GET_ORGANIZATIONS,
    GET_ORGANIZATIONS_SUCCESS,
    GET_ORGANIZATIONS_FAIL, 
    GET_ORGANIZATIONS_RESET,
} from "../actions/getOrganizationsAction";

const initialState = {
    apiState: "",
    message: "",
    data: null,
    error: "",
}

const getOrganizationsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ORGANIZATIONS:
            return {
                ...state,
                apiState: "loading",
            };
        case GET_ORGANIZATIONS_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data,
                message: action.response.message ? action.response.message : "success",
            };
        case GET_ORGANIZATIONS_FAIL:
            return {
                ...state,
                apiState: "error",
                error: action.response.errors,
                message: action.response.message ? action.response.message : "error",
            };
        case GET_ORGANIZATIONS_RESET:
            return initialState;
        default: 
            return state;
    }
};

export default getOrganizationsReducer;
